import React, {Component} from 'react';
import './styles/styles.css'
import { ConnectedRouter } from 'react-router-redux'
import {connect} from 'react-redux';
import {changeLoginForm} from './actions/login';
import {Route, Switch} from 'react-router';
import LayoutHOC from './containers/LayoutHOC';
import {parseLogin} from "./helpers/parseImmutables";
import LoggedOutRouter from "./routers/loggedOutRouter";
import './styles/general.css';

class App extends Component {
    render() {
        var renderComp;
        if (this.props.isAuth === true) {
            renderComp = <div>
                <Switch>
                    <Route path="/" component={LayoutHOC} />
                </Switch>
            </div>
        }
        else if (this.props.isAuth  === false) {
            renderComp = <div>
                <Switch>
                    <Route path="/" component={LoggedOutRouter}/>
                </Switch>
            </div>
        }
        return (
            <ConnectedRouter history={ this.props.History }>
                {renderComp}
            </ConnectedRouter>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        isAuth: parseLogin(state.login).isAuth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeInfo: (key, value) => {
            dispatch(changeLoginForm(key, value))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/App.js